const UNSUPPORTED_METRICS_ANNOTATION = 'unsupportedMetricsInRequest';

export interface UnsupportedMetricsInfo {
  metrics: string[];
  cause: string;
}

export const emptyUnsupportedMetrics: UnsupportedMetricsInfo = { metrics: [], cause: '' };

// parse the `unsupportedMetricsInRequest` annotation from the v1.0/metrics response
// into the affected metric keys + cause message for per-card display.
export function parseUnsupportedMetrics(annotations = []): UnsupportedMetricsInfo {
  try {
    const anno = (annotations || []).find((item) => item?.type === UNSUPPORTED_METRICS_ANNOTATION);
    return {
      metrics: Array.isArray(anno?.value) ? anno.value : [],
      cause: anno?.cause ?? '',
    };
  } catch (err) {
    console.error('failed to parse unsupported metrics annotation');
    return emptyUnsupportedMetrics;
  }
}
